/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class PreventiveSheetTemplateService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'PreventiveSheetTemplateService\' loaded');
    }
}

export { PreventiveSheetTemplateService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/prevention/service/PreventiveSheetTemplateService.js